import { render, staticRenderFns } from "./officeTab.vue?vue&type=template&id=0e12b0b4&scoped=true&"
import script from "./officeTab.vue?vue&type=script&lang=js&"
export * from "./officeTab.vue?vue&type=script&lang=js&"
import style0 from "./officeTab.vue?vue&type=style&index=0&id=0e12b0b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e12b0b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e12b0b4')) {
      api.createRecord('0e12b0b4', component.options)
    } else {
      api.reload('0e12b0b4', component.options)
    }
    module.hot.accept("./officeTab.vue?vue&type=template&id=0e12b0b4&scoped=true&", function () {
      api.rerender('0e12b0b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/role/officeTab.vue"
export default component.exports